export default "__VITE_ASSET__C2xa062T__";